<template>
  <div class="unauth">
    <div class="auth-mention">
      <div class="mention-item">
        <i class="el-icon-info"></i>
        公司授权公众号后，可使用完整功能，包括：
      </div>
      <div class="mention-item second-mention">
        1. 营销素材：营销素材可设置打标签规则，当微信用户访问营销素材时，给TA打上对应的内容标签；也可通过表单收集线索&客户的信息
      </div>
      <div class="mention-item second-mention">
        2. 线索：可正常使用线索模块。当微信用户访问营销素材后，能获取其微信信息，使其成为线索
      </div>
      <div class="mention-item second-mention">
        3. 公众号管理：可同步公众号的粉丝、创建公众号二维码，使用公众号进行自动回复和群发消息等
      </div>
    </div>
    <div class="select">
      <div class="select-item">
        <div class="con">
          <div class="img">
            <mk-iconfont
              class="img-icon"
              icon-class="wx-danren"
            ></mk-iconfont>
          </div>
          <div class="all-tips">
            <p>1. 请使用和企业微信相同主体的微信公众号</p>
            <p>2. 公众号必须是企业为主体，认证的服务号</p>
            <p>3. 授权时请确保所有权限被勾选</p>
          </div>
        </div>
        <div
          class="btn highlight"
          @click="toAuth"
        >
          已有公众号，立即绑定
        </div>
      </div>
      <div class="select-item none">
        <div class="con">
          <div class="img">
            <mk-iconfont
              class="img-icon"
              icon-class="wx-danren"
            ></mk-iconfont>
          </div>
          <div class="all-tips">
            <p>请在微信公众平台申请新的公众号，</p>
            <p>成功后再到此页面进行绑定</p>
          </div>
        </div>
        <div class="btn">
          <a
            href="https://mp.weixin.qq.com"
            target="_blank"
          >没有公众号，立即申请</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
const { VUE_APP_PC_B_BASE_URL, VUE_APP_WX_OPEN_BASE_URL } = process.env
export default {
  name: 'Unauth',
  data () {
    return {
      hintList: [
        '说明：',
        '1、授权的微信公众号必须是微信认证的服务号。',
        '2、确保小程序和公众号主体保持一致',
        '3、授权时请保持默认选择，再点击【自定义权限】→选中【开放平台账号管理】权限，将权限统一交给尘锋'
      ]
    }
  },
  computed: {
    ...mapState('system', [
      'systemConfig'
    ])
  },
  mounted () {
    this.$set(this.hintList, 3, this.hintList[3].replace('尘锋', this.systemConfig.oem.productName))
  },
  methods: {
    // 授权事件
    toAuth () {
      const dustessUrl = encodeURIComponent(
        window.location.origin + '/#/settings/auth-management'
      )
      const { account } = JSON.parse(window.localStorage.getItem('user'))
      const url = `${VUE_APP_WX_OPEN_BASE_URL}/wxopen/v1/auth/page?companyId=${account}&dustessUrl=${dustessUrl}`
      window.open(url)
      this.$emit('validateDialog', true)
    }
  }
}
</script>
<style lang="scss" scoped>
.unauth {
  padding: 23px 25px 0;

  .auth-mention {
    padding: 5px 16px;
    background: #f2fbff;
    border: 1px solid #ccecff;
    border-radius: 4px;

    .mention-item {
      color: #000;
      font-size: 14px;
      line-height: 30px;

      .el-icon-info {
        color: #009cff;
        margin-right: 6px;
        font-size: 16px;
      }
    }

    .second-mention {
      margin-left: 22px;
    }
  }

  .select {
    margin-top: 23px;
    display: flex;

    .select-item {
      width: 470px;
      height: 184px;
      border: 1px solid #e9e9e9;
      border-radius: 2px;
      display: flex;
      flex-direction: column;

      .con {
        display: flex;
        align-items: center;
        height: 100%;

        .img {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          background-color: #ffbf00;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 16px 0 25px;

          .img-icon {
            font-size: 24px;
            color: #fff;
          }
        }

        .all-tips {
          color: rgba(0, 0, 0, 0.45);
          font-size: 14px;
          line-height: 24px;
          margin-right: 25px;
        }
      }

      .btn {
        flex-shrink: 0;
        height: 48px;
        line-height: 48px;
        text-align: center;
        background: #f7f9fa;
        border-radius: 0 0 2px 2px;
        border-top: 1px solid #e9e9e9;
        color: rgba(0, 0, 0, 0.45);
        cursor: pointer;

        &:hover {
          background-color: #009cff;
          color: #fff !important;
        }
      }

      .btn.highlight {
        color: #009cff;
      }
    }

    .select-item.none {
      margin-left: 25px;

      .img {
        background-color: #d9d9d9;
      }

      .btn {
        background-color: #f7f9fa;
        color: rgba(0, 0, 0, 0.45);

        a {
          display: block;
          width: 100%;
          height: 100%;
          color: rgba(0, 0, 0, 0.45);
          text-decoration: none;
        }

        &:hover {
          background-color: #009cff;
          color: #fff;

          a {
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
